// extracted by mini-css-extract-plugin
export default {"customPopover":"style_customPopover__lPRVe"};